import { Stack } from '@mui/material'
import React from 'react'
import { isEmpty } from 'lodash'
import { shallowEqual, useDispatch, useSelector } from 'react-redux'
import AgriAction from 'agriAdministration/actions/AgriAction'
import ProgressCard from 'components/card/ProgressCard'
import { Outlet } from 'react-router'
import { NoDataCard } from 'components/card/NoDataCard'
import HydrometryAction from 'hydrometry/actions/HydrometryAction'
import useProgressDispatch from 'utils/customHook/useProgressDispatch'
import PiezometryAction from 'piezometry/actions/PiezometryAction'
import { compact } from 'lodash'
import PiezometerStationAction from 'station/actions/PiezometerStationAction'

const TerritoryA3PApp = () => {
    const {
        A3PDetails,
    } = useSelector(store => ({
        A3PDetails: store.AgriReducer.A3PDetails,
    }), shallowEqual)

    const dispatch = useDispatch()

    const { progress, isLoaded } = useProgressDispatch(() => compact([
        dispatch(HydrometryAction.fetchHydrometryDataTypes()),
        dispatch(HydrometryAction.fetchHydrometricThresholds()),
        dispatch(PiezometryAction.fetchPiezometryDataTypes()),
        dispatch(PiezometerStationAction.fetchAllPiezometerThreshold()),
        isEmpty(A3PDetails) && dispatch(AgriAction.fetchA3PDatas({
            climateParams: {
                dry: false,
                normal: false,
                damp: false,
            },
            onlyInRiskOfShortage: false,
        })),
    ]), [])

    return (
        <Stack>
            {isLoaded ?
                isEmpty(A3PDetails) ?
                    <NoDataCard />
                    :
                    <Outlet />
                :
                <ProgressCard progress={progress} />
            }
        </Stack>
    )
}

export default TerritoryA3PApp